import { Button } from '@/components/Button/Button';
import { BASE_USER_ROLES } from '@/common/constants/user';
import TileCarousel from '@/domains/home/widgets/TileCarousel';
import AuthStore from '@/stores/AuthStore';
import FridgeDoorStore from '@/stores/FridgeDoorStore';
import { Group } from '@/types/Content/Group';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import Link from 'next/link';
import {
  BrowseMoreButtonContainer,
  ContentContainer,
  RecommendedGroupsContainer,
  StyledGroupCard,
  TileCarouseContainer,
  Title,
} from './RecommendedGroupSection.styles';

function RecommendedGroupsSection({
  groups,
}: {
  groups: Array<Group>;
}): JSX.Element {
  const [recommendedGroups, setRecommendedGroups] = useState([]);
  useEffect(() => {
    setRecommendedGroups(groups);
  }, [groups]);

  const { priorityRole } = AuthStore;
  const { currentVillageId } = FridgeDoorStore;

  function isSupporterMember() {
    return priorityRole.label === BASE_USER_ROLES.SUPPORTER;
  }

  return (
    <RecommendedGroupsContainer>
      {recommendedGroups &&
      recommendedGroups.length &&
      recommendedGroups[0].group?.slug ? (
        <>
          <Title>More like this</Title>
          {recommendedGroups?.map(
            // eslint-disable-next-line react/no-unused-prop-types
            ({ group: currentGroup }: { group: Group }) =>
              currentGroup && (
                <>
                  <ContentContainer key={currentGroup.slug}>
                    <StyledGroupCard
                      slug={currentGroup.slug}
                      users={currentGroup.users}
                      groupName={currentGroup.name}
                      groupId={currentGroup.groupId}
                      groupImage={currentGroup.image}
                      totalUsers={currentGroup.totalUsers}
                      groupDescription={currentGroup.description}
                    />
                    <TileCarouseContainer>
                      <TileCarousel
                        arrowColor="black"
                        defaultSlidesToShow={3}
                        villageId={currentVillageId}
                        contentList={currentGroup.content}
                        isSupporterMember={isSupporterMember()}
                      />
                    </TileCarouseContainer>
                  </ContentContainer>
                  <BrowseMoreButtonContainer>
                    <Link href="/discover">
                      <Button>Browse more</Button>
                    </Link>
                  </BrowseMoreButtonContainer>
                </>
              ),
          )}
        </>
      ) : (
        <div />
      )}
    </RecommendedGroupsContainer>
  );
}

export default observer(RecommendedGroupsSection);
